/* eslint-disable max-len */
export const contactForm =
  'https://outlook.office.com/book/BharatCarbon1@bharatcarbon.earth/s/DZS8WaeHbkaQGY2QfQSAXA2?ismsaljsauthenabled';
